import React, { useState, useEffect } from "react";
import Styled from "styled-components";
import { Modal, Typography } from "antd";
import { TextCol } from "views/mobile/screens/SignUpModal/styles";
import { Spacer } from "views/components/common/Spacer";
import Input from "views/components/common/Input/Input";
import { ModalButton } from "views/components/ModalButton";
import { MailOutlined } from "@ant-design/icons";
import { useLoginModalTicket } from "hooks/useLoginModalTicket";
import { pathOr } from "ramda";
import { useAccountForModal } from "hooks/recover";
const { Text } = Typography;

export const RequestPassModal = ({
	desktop,
	user,
	visible,
	setShowModal,
	onCloseModal,
	getReservation,
	blockreservation,
	ticketAction,
	goToLogin,
}) => {
	const [showRecovery, setShowRecovery] = useState(false);
	const [isSend, setIsSend] = useState(false);
	const [inputs, setInputs] = useState({ password: "" });
	const [disableButton, setDisableButton] = useState(false);

	const [onlyEmail, setOnlyEmail] = useState(false);
	const [userEmail, setUserEmail] = useState({ user: user.email });
	const [recover, loadingRecover, errorRecover, successRecover] =
		useAccountForModal();
	const onCancel = () => {
		setShowModal(false);
	};

	const handleGoToLogin = () => {
		goToLogin();
		onClose();
	};

	const onClickRecoveryPass = (user) => {
		recover(user).then(() => setIsSend(true));
	};

	const onChangeOnlyEmail = ({ input, value }) => {
		setOnlyEmail({ ["user"]: value });
	};

	const onClose = () => {
		onCloseModal();
		onCancel();
	};
	const [submit, success, loading, error] = useLoginModalTicket(
		onClose,
		getReservation,
		blockreservation
	);

	const onClickRecovery = () => {
		setShowRecovery(true);
	};
	const onChangeInputs = ({ input, value }) => {
		setInputs((i) => ({ ...i, [input]: value }));
	};

	const isPassword = pathOr(false, ["password"], inputs);
	const isDisabled =
		isPassword === "" ? true : isPassword.length <= 7 ? true : false;

	useEffect(() => {
		if (user && user.email)
			setInputs((i) => ({ ...i, ["email"]: user.email }));
	}, [user]);

	useEffect(() => {
		if (success) {
			return ticketAction();
		}
	}, [success]);

	useEffect(() => {
		successRecover ? setDisableButton(true) : setDisableButton(false);
	}, [successRecover]);

	return (
		<ModalContainer
			style={{
				display: "flex",
				justifyContent: "center",
				marginBottom: "128px",
			}}
			maskClosable={false}
			desktop={desktop}
			visible={visible}
			closeIcon={false}
			footer={false}
			onCancel={onCancel}
			destroyOnClose
		>
			<div>
				{!showRecovery && (
					<>
						<TextCol>
							<Text
								className="modal__text-welcome"
								type="secondary"
							>
								Ya tienes una cuenta con
							</Text>
							<Spacer rows={0.5} />
							<Text className="title__signup-email">
								{user.email || ""}
							</Text>
							<Spacer rows={0.5} />

							{error && (
								<>
									<Text
										className="title__signup-flow-error"
										type={"secondary"}
									>
										{error.EmailMessage}
									</Text>
								</>
							)}
						</TextCol>
						<Input
							name="password"
							label="Contraseña"
							placeholder=""
							required={true}
							type="password-strong"
							onChange={onChangeInputs}
						/>
						<div
							className="pass__recover "
							onClick={onClickRecovery}
						>
							<div>¿Olvidaste tu contraseña?</div>
						</div>
						<Spacer rows={1} />
						<ModalButton
							disabled={loading || isDisabled}
							loading={loading}
							label="Ingresar"
							type="primary"
							onClick={() => submit(inputs)}
						></ModalButton>
						<Spacer rows={1} />
						<div
							className="signup__another-email"
							onClick={handleGoToLogin}
						>
							Usar otro correo electrónico
						</div>
					</>
				)}

				{showRecovery && (
					<>
						{!isSend && (
							<>
								<TextCol>
									<Text className="title__login-modal">
										¿Olvidaste tu contraseña?
									</Text>
									<Spacer rows={0.5} />
									<Text className="modal__text-welcome">
										Ingresa el email asociado a tu cuenta
									</Text>
									<Spacer rows={0.5} />
									<Text
										className="modal__text-welcome-light"
										type="secondary"
									>
										Te enviaremos un enlace con las
										instrucciones para restablecer la
										contraseña
									</Text>
									<Input
										name="user"
										label="Email"
										placeholder={user.email}
										required={true}
										type="email"
										onChange={onChangeOnlyEmail}
									/>
								</TextCol>

								<ModalButton
									disabled={
										loadingRecover ||
										!userEmail ||
										!onlyEmail
									}
									loading={loadingRecover}
									label="Restablecer contraseña"
									type="primary"
									onClick={() =>
										onClickRecoveryPass(
											onlyEmail.user === ""
												? userEmail
												: onlyEmail
										)
									}
								></ModalButton>
							</>
						)}
						{isSend && (
							<>
								<TextCol>
									<MailOutlined
										style={{
											fontSize: 42,
											color: "#145AB4",
										}}
									/>
									<Spacer rows={0.5} />
									<Text className="title__login-modal">
										¡Email enviado!
									</Text>
									<Spacer rows={0.5} />

									<Text
										className="modal__text-welcome-light"
										type="secondary"
									>
										Te enviaremos un enlace con las
										instrucciones para restablecer la
										contraseña
									</Text>

									<Spacer rows={0.5} />
									<Text className="modal__text-welcome">
										{onlyEmail.user === ""
											? userEmail.user
											: onlyEmail.user}
									</Text>
								</TextCol>
								<ModalButton
									disabled={loadingRecover || disableButton}
									loading={loadingRecover}
									label="Enviar de nuevo"
									type="primary"
									onClick={() =>
										onClickRecoveryPass(
											onlyEmail.user === ""
												? userEmail
												: onlyEmail
										)
									}
								></ModalButton>
								<Spacer rows={0.5} />
								{disableButton && (
									<Text
										className="modal__text-welcome-light"
										type="secondary"
									>
										Debes esperar 30 segundos para enviar
										nuevamente.
									</Text>
								)}
							</>
						)}
					</>
				)}
			</div>
		</ModalContainer>
	);
};

const ModalContainer = Styled(Modal)`


.title__signup-flow-error {
    font-size: 12px;
    color: #b41414;
    position: absolute;
    top: 100%;
   
}

.ant-modal-close {
    width: 30px;
}
.signup__another-email {
        width: 100%;
        text-align: center;
		color:#145AB4;

        :hover {
            cursor: pointer;
            text-decoration: underline
        }
    
        
		}


.pass__recover {
		text-align: right;
		& div {
			font-size:14px;
			font-weight:400;
			text-decoration: underline;
			color: #505050
		}

        & :hover {
            cursor:pointer;
        }
	}
& button {
    width: 100%
}
.ant-modal-close-x {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 12px;
  
}
.ant-modal-body {
    width: 100%
}
    .title__login-modal {
		font-weight: 800;
		font-size:16px;
		color:#145AB4
	}
	
	.title__signup-email {
        font-weight: 800;
		font-size:16px;
    }
	
	.modal__text-welcome {
		font-size: 14px;
		font-weight: 600;
		color: #505050
	}

    .modal__text-welcome-light {
        font-size: 14px;
        
		color: #505050
    }
	@media (min-width: 768px) {
	
		.modal__text-welcome {
			width:400px
		}

	}

	.signup__already-registered-anchor {
			color:#145AB4
		}
		
		.noregistry__ticket-label{
		font-weight:700;
		text-decoration: underline;
		color:#145AB4
		
	}

  .ant-modal-content {

      height: ${(props) => (props.desktop ? "378px" : "380px")};
      width: ${(props) => (props.desktop ? "364px" : "350px")};
      display: flex;
      justify-content: center;
      
      
`;
